export default __webpack_public_path__ + "static/media/cp_geo_ro.028cf08f.svg";